// @ts-ignore
import { logUtil } from "@repo/lib-common";
import { DomainSubject } from "./domainSubject";
import { domContentLoadedSubject } from "./domContentLoadedSubject";



const maxTcfCheckCount = 5;
export class TcfReadySubject extends DomainSubject<any> {
    name = "TcfReadySubject";
    tcfCheckCount = 0;
    checkTCF(): boolean {
        // @ts-ignore
        let isTcfLoaded = (typeof window.__tcfapi !== "undefined") && (typeof window.__tcfapi === "function") && window.__tcfapi !== "undefined";

        if (isTcfLoaded) return isTcfLoaded;
        try {
            // @ts-ignore
            isTcfLoaded = (typeof window.frames !== "undefined") && (typeof window.frames.__tcfapi !== "undefined");
        } catch (e) { /* empty */ }
        return isTcfLoaded;
    }
    init = () => {
        if (this.tcfCheckCount > maxTcfCheckCount) {
            logUtil.consoleWarn("tcf not found on page");
            return;
        }
        this.tcfCheckCount++;
        if (this.checkTCF()) {
            // @ts-ignore
            __tcfapi('addEventListener', 2, (tcData) => {
                console.log(tcData);
                logUtil.consoleLog("tcf->tcData", tcData);
                // @ts-ignore
                this.setDataAndTrigger(this.tcData);

            });
        } else {
            setTimeout(() => {
                this.init();
            }, 500);
        }

    }
}

const tcfReadySubject = new TcfReadySubject();



/** attach to the dom content load event */
domContentLoadedSubject.subscribe(() => { tcfReadySubject.activate() });
export { tcfReadySubject };




